import React, {ReactNode} from 'react';

import cs from 'classnames';
import styled from 'styled-components';

import {OptionalClassNameProps} from 'app/general/bootstrap/utils';

const StyledTitle = styled.div.attrs<OptionalClassNameProps>({
  className: 'm-0',
})`
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  padding-left: 15px;
  padding-right: 15px;

  h5 {
    text-transform: uppercase;
    font-weight: bold;
  }

  .actions-box button {
    border: none;
  }
`;

type Props = {
  title?: ReactNode;
  actionsBox?: ReactNode;
  className?: string;
  paddingRightClass?: string;
};

export const ViewModeTitle = ({
  title,
  actionsBox,
  className,
  paddingRightClass = 'pr-2',
}: Props): JSX.Element => (
  <StyledTitle
    className={cs(
      'd-flex align-items-center justify-content-between',
      paddingRightClass,
      className
    )}
  >
    {title ? <h5 className="my-2 text-truncate">{title}</h5> : null}
    {actionsBox != null ? (
      <div className="actions-box">{actionsBox}</div>
    ) : null}
  </StyledTitle>
);
